import React from 'react';

type ThemeContextType = {
  theme: any;
  setTheme: (theme: any) => void;
};

export const ThemeContext = React.createContext<ThemeContextType | null>(null);
